import { render, staticRenderFns } from "./importXLS.vue?vue&type=template&id=a425e0f4"
import script from "./importXLS.vue?vue&type=script&lang=js"
export * from "./importXLS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports